<template>
  <div class="order-statistics">
    <a-spin :spinning="loading">
      <div class="statistics-row">
        <div
          v-for="(item, index) in newStatisticsConfig"
          :key="index"
          class="statistics-item"
        >
          <div class="statistics-content">
            <div class="statistics-title">{{ item.title }}</div>
            <div class="statistics-value" :style="{ color: item.color }">
              {{ formatValue(statisticsData[item.field], item) }}
            </div>
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
// import { formatAmount } from '@/utils/util'

export default {
  name: 'OrderStatistics',
  props: {
    // 统计数据
    statisticsData: {
      type: Object,
      default: () => ({})
    },
    // 加载状态
    loading: {
      type: Boolean,
      default: false
    },
    isPayOut: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // 统计配置
      statisticsConfig: [
        {
          title: '订单总数',
          field: 'totalOrderCount',
          color: '#1890ff',
          type: 'number'
        },
        {
          title: '订单总金额',
          field: 'totalOrderAmount',
          color: '#52c41a',
          type: 'amount'
        },
        {
          title: '完成订单数',
          field: 'completeOrderCount',
          color: '#52c41a',
          type: 'number'
        },
        {
          title: '完成订单金额',
          field: 'completeOrderAmount',
          color: '#52c41a',
          type: 'amount'
        },
        {
          title: '订单手续费',
          field: 'totalOrderFee',
          color: '#fa8c16',
          type: 'amount'
        },
        {
          title: '支付中订单数',
          field: 'unpaidOrderCount',
          color: '#faad14',
          type: 'number'
        },
        {
          title: '支付中订单金额',
          field: 'unpaidOrderAmount',
          color: '#ff4d4f',
          type: 'amount'
        }
      ],
      extraConfig: [
        {
          title: '待审核订单数',
          field: 'reviewCount',
          color: '#faad14',
          type: 'number'
        },
        {
          title: '待审核订单金额',
          field: 'reviewAmount',
          color: '#ff4d4f',
          type: 'amount'
        }
      ]
    }
  },
  computed: {
    newStatisticsConfig () {
      return this.isPayOut ? this.statisticsConfig.concat(this.extraConfig) : this.statisticsConfig
    }
  },
  methods: {
    // 格式化显示值
    formatValue (value, config) {
      console.log('value', value)
      if (value === null || value === undefined) {
        return config.type === 'amount' ? '₹0.00' : '0'
      }

      if (config.type === 'amount') {
        // return `₹${value}`
        return `₹${Number(value).toLocaleString('en-US')}`
      } else {
        // 数字类型，添加千分位分隔符
        return value
        // return Number(value).toLocaleString('en-IN')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.order-statistics {
  margin-bottom: 16px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.1);

}

.statistics-row {
  display: flex;
  flex-wrap: wrap;
  border-radius: 6px;
  overflow: hidden;
}

.statistics-item {
  flex: 1;
  min-width: 150px;
  padding: 20px 16px;
  background: #fff;
  border-right: 1px solid #f0f0f0;
  text-align: center;
  transition: all 0.3s ease;

  &:last-child {
    border-right: none;
  }

  &:hover {
    background: #fafafa;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}

.statistics-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.statistics-title {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  line-height: 1.4;
  white-space: nowrap;
}

.statistics-value {
  font-size: 16px;
  font-weight: bold;
  line-height: 1.2;
}

// 响应式布局
@media (max-width: 1400px) {
  .statistics-item {
    min-width: 120px;
    padding: 12px 8px;
  }

  .statistics-value {
    font-size: 14px;
  }
}

@media (max-width: 1200px) {
  .statistics-row {
    flex-direction: column;
  }

  .statistics-item {
    min-width: auto;
    flex: none;
    border-right: none;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
    }
  }
}

@media (max-width: 768px) {
  .statistics-item {
    padding: 8px;
  }

  .statistics-title {
    font-size: 12px;
  }

  .statistics-value {
    font-size: 14px;
  }
}
</style>
